export { default as ProductInfo } from './product-info';
